declare var window;
import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { Player, UserSettings } from "src/models/player.model";


@Injectable({
   providedIn: 'root',
})
export class UserService {
   public EventUserUpdate: EventEmitter<Player> = new EventEmitter<Player>();
   private player: Player = null;
   private userSettings: UserSettings[] = [];

   constructor(private http: HttpClient) {
   }

   public clearCache() {
      this.player = null;
      this.userSettings = [];
   }

   public getUser(): Observable<Player> {
      if (this.player == null || Object.keys(this.player).length === 0 && this.player.constructor === Object)
         return this.http.get<Player>('/User')
            .pipe(
               catchError(err => {
                  this.clearCache();
                  localStorage.removeItem('ladderId');
                  localStorage.removeItem('levelId');
                  window.location.reload();

                  // this is irrelavent other than the compiler
                  return of(new Player())
               }
               ),
               tap(p => { this.player = p; this.EventUserUpdate.emit(p); })
            );
      else return of(this.player);
   }

   public getLaddersAndLevels(): Observable<UserSettings[]> {
      if (this.userSettings.length == 0) {
         return this.http.get<UserSettings[]>('/User/LaddersAndLevels')
            .pipe(tap(p => { this.userSettings = p; }));
      }
      else return of(this.userSettings);
   }

   // note: be sure to wipe/overwrite the cache here with the pipe because the message may have changed
   public setUserMessage(m: string, showMessageUntil?: Date): Observable<Player> {
      return this.http.post<Player>('/User/SetMessage', { message: m, showMessageUntil: showMessageUntil })
         .pipe(tap(p => { this.player = p; this.EventUserUpdate.emit(p); }));
   }
}
